import { render } from "./AlumniBannerty.vue?vue&type=template&id=22a9208e&scoped=true"
import script from "./AlumniBannerty.vue?vue&type=script&lang=js"
export * from "./AlumniBannerty.vue?vue&type=script&lang=js"

import "./AlumniBannerty.vue?vue&type=style&index=0&id=22a9208e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a9208e"]])

export default __exports__